// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content.gridster-item-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  height: calc(100% - 30px);
}

.master-detail {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.list-panel {
  width: 220px;
  min-width: 180px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--mat-sys-outline-variant);
  background: var(--mat-sys-surface);
  overflow: hidden;
}
.list-panel .list-header {
  flex-shrink: 0;
  border-bottom: 1px solid var(--mat-sys-outline-variant);
}
.list-panel .feature-list {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;
}
.list-panel .feature-list::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
}
.list-panel .feature-list::-webkit-scrollbar-track {
  background: transparent !important;
}
.list-panel .feature-list::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7) !important;
  border-radius: 4px !important;
}
.list-panel .feature-list::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9) !important;
}
.list-panel .feature-list::-webkit-scrollbar-corner {
  background: transparent !important;
}
.list-panel .feature-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--mat-sys-outline-variant);
  transition: background-color 0.1s ease;
}
.list-panel .feature-item:hover {
  background: var(--mat-sys-surface-variant);
}
.list-panel .feature-item.selected {
  background: var(--mat-sys-primary-container);
  border-left: 3px solid var(--mat-sys-primary);
  padding-left: 9px;
}
.list-panel .feature-item .feature-name {
  display: block;
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-panel .feature-item .script-name {
  display: block;
  font-size: 11px;
  color: var(--mat-sys-on-surface-variant);
  font-family: monospace;
}
.list-panel .empty-state {
  padding: 24px 12px;
  text-align: center;
  color: var(--mat-sys-on-surface-variant);
  font-size: 13px;
}
.list-panel .empty-state p {
  margin: 0;
}
.list-panel .list-footer {
  flex-shrink: 0;
  padding: 8px;
  border-top: 1px solid var(--mat-sys-outline-variant);
}
.list-panel .list-footer button {
  width: 100%;
  justify-content: flex-start;
}

.detail-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--mat-sys-surface-container);
}

.no-selection {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--mat-sys-on-surface-variant);
}
.no-selection mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}
.no-selection p {
  margin: 0;
}

.loading-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--mat-sys-outline-variant);
  background: var(--mat-sys-surface);
  flex-shrink: 0;
}
.detail-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}
.detail-header .header-actions {
  display: flex;
  gap: 4px;
}

.new-feature-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.new-feature-form .form-section {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}
.new-feature-form .section-label {
  font-size: 13px;
  color: var(--mat-sys-on-surface-variant);
  margin-bottom: 12px;
}
.new-feature-form .script-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.new-feature-form .script-option {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 4px;
  background: var(--mat-sys-surface);
  border: 1px solid var(--mat-sys-outline-variant);
  cursor: pointer;
  font-size: 13px;
}
.new-feature-form .script-option:hover {
  background: var(--mat-sys-surface-variant);
  border-color: var(--mat-sys-primary);
}
.new-feature-form .script-option mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--mat-sys-primary);
}
.new-feature-form .full-width {
  width: 100%;
}
.new-feature-form .selected-script {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0;
  font-size: 13px;
  color: var(--mat-sys-on-surface-variant);
}
.new-feature-form .selected-script mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.new-feature-form .form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.form-pane {
  padding: 16px;
  border-bottom: 1px solid var(--mat-sys-outline-variant);
  background: var(--mat-sys-surface);
  flex-shrink: 0;
}
.form-pane .params-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.form-pane .params-grid .param-field {
  flex: 0 0 calc(33.333% - 8px);
  min-width: 150px;
}
.form-pane .no-params {
  color: var(--mat-sys-on-surface-variant);
  font-size: 13px;
  font-style: italic;
}
.form-pane .no-params p {
  margin: 0;
}

.test-pane {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow: hidden;
}
.test-pane .test-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.test-pane .test-controls .dataset-field {
  flex: 0 0 180px;
}
.test-pane .test-controls .index-field {
  flex: 0 0 150px;
}
.test-pane .test-output {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.test-pane .test-output .output-timestamp {
  font-size: 11px;
  color: var(--mat-sys-on-surface-variant);
  margin-bottom: 8px;
}
.test-pane .test-output .output-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: var(--mat-sys-error-container);
  color: var(--mat-sys-on-error-container);
  border-radius: 4px;
}
.test-pane .test-output .output-table-container {
  flex: 1;
  overflow: auto;
  border: 1px solid var(--mat-sys-outline-variant);
  border-radius: 4px;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;
}
.test-pane .test-output .output-table-container::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
}
.test-pane .test-output .output-table-container::-webkit-scrollbar-track {
  background: transparent !important;
}
.test-pane .test-output .output-table-container::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7) !important;
  border-radius: 4px !important;
}
.test-pane .test-output .output-table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9) !important;
}
.test-pane .test-output .output-table-container::-webkit-scrollbar-corner {
  background: transparent !important;
}
.test-pane .test-output .output-table-container .output-table {
  width: 100%;
  font-size: 12px;
}
.test-pane .test-output .output-table-container .output-table th, .test-pane .test-output .output-table-container .output-table td {
  padding: 6px 10px;
  font-family: monospace;
}
.test-pane .test-output .output-table-container .output-table th {
  background: var(--preset-card, var(--mat-sys-surface-container, #f5f5f5));
  position: sticky;
  top: 0;
  font-weight: 500;
}

::ng-deep .output-table .mat-mdc-header-row .mat-mdc-header-cell {
  background: var(--preset-card, var(--mat-sys-surface-container, #f5f5f5)) !important;
  color: var(--mat-sys-on-surface-variant) !important;
}
::ng-deep .output-table .mat-mdc-row .mat-mdc-cell {
  color: var(--mat-sys-on-surface) !important;
}

::ng-deep .param-field .mat-mdc-form-field-subscript-wrapper,
::ng-deep .dataset-field .mat-mdc-form-field-subscript-wrapper,
::ng-deep .index-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
::ng-deep .param-field .mat-mdc-text-field-wrapper,
::ng-deep .dataset-field .mat-mdc-text-field-wrapper,
::ng-deep .index-field .mat-mdc-text-field-wrapper {
  padding: 0 12px;
}
::ng-deep .param-field .mat-mdc-form-field-infix,
::ng-deep .dataset-field .mat-mdc-form-field-infix,
::ng-deep .index-field .mat-mdc-form-field-infix {
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 40px;
}

.mat-menu-item.active {
  background: var(--mat-sys-primary-container);
}

::ng-deep .calculate-btn.calculating.mat-mdc-raised-button:disabled {
  background-color: var(--mat-sys-primary) !important;
  opacity: 1 !important;
}
::ng-deep .calculate-btn.calculating.mat-mdc-raised-button:disabled .mdc-button__label {
  color: white !important;
}
::ng-deep .calculate-btn.calculating.mat-mdc-raised-button:disabled .mat-mdc-button-persistent-ripple {
  opacity: 0 !important;
}
::ng-deep .calculate-btn.calculating .mat-mdc-progress-spinner circle {
  stroke: white !important;
}

.button-spinner {
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}

::ng-deep .mat-mdc-select-panel {
  background-color: var(--mat-sys-surface-container) !important;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar {
  width: 8px !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-track {
  background: transparent !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7) !important;
  border-radius: 4px !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option {
  color: var(--mat-sys-on-surface) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option:hover:not(.mdc-list-item--disabled) {
  background-color: var(--mat-sys-surface-variant) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) {
  background-color: var(--mat-sys-primary-container) !important;
  color: var(--mat-sys-on-primary-container) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/feature-editor-widget/feature-editor-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AA5BF;;AAgCA;EACE,aAAA;EACA,OAAA;EACA,gBAAA;AA7BF;;AAiCA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,sDAAA;EACA,kCAAA;EACA,gBAAA;AA9BF;AAgCE;EACE,cAAA;EACA,uDAAA;AA9BJ;AAiCE;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EA3DF,gCAAA;EACA,gEAAA;AA6BF;AA3BE;EACE,qBAAA;EACA,sBAAA;AA6BJ;AA1BE;EACE,kCAAA;AA4BJ;AAzBE;EACE,+CAAA;EACA,6BAAA;AA2BJ;AAzBI;EACE,+CAAA;AA2BN;AAvBE;EACE,kCAAA;AAyBJ;AAgBE;EACE,kBAAA;EACA,eAAA;EACA,uDAAA;EACA,sCAAA;AAdJ;AAgBI;EACE,0CAAA;AAdN;AAiBI;EACE,4CAAA;EACA,6CAAA;EACA,iBAAA;AAfN;AAkBI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBN;AAmBI;EACE,cAAA;EACA,eAAA;EACA,wCAAA;EACA,sBAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;AAnBJ;AAqBI;EACE,SAAA;AAnBN;AAuBE;EACE,cAAA;EACA,YAAA;EACA,oDAAA;AArBJ;AAuBI;EACE,WAAA;EACA,2BAAA;AArBN;;AA2BA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,4CAAA;AAxBF;;AA2BA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;AAxBF;AA0BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAxBJ;AA2BE;EACE,SAAA;AAzBJ;;AA8BA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,uDAAA;EACA,kCAAA;EACA,cAAA;AA5BF;AA8BE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,QAAA;AA7BJ;;AAkCA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AA/BF;AAiCE;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AA/BJ;AAkCE;EACE,eAAA;EACA,wCAAA;EACA,mBAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,gDAAA;EACA,eAAA;EACA,eAAA;AAlCJ;AAoCI;EACE,0CAAA;EACA,oCAAA;AAlCN;AAqCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;AAnCN;AAuCE;EACE,WAAA;AArCJ;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,wCAAA;AAtCJ;AAwCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtCN;AA0CE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AAxCJ;;AA6CA;EACE,aAAA;EACA,uDAAA;EACA,kCAAA;EACA,cAAA;AA1CF;AA4CE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA1CJ;AA4CI;EACE,6BAAA;EACA,gBAAA;AA1CN;AA8CE;EACE,wCAAA;EACA,eAAA;EACA,kBAAA;AA5CJ;AA8CI;EACE,SAAA;AA5CN;;AAkDA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AA/CF;AAiDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AA/CJ;AAiDI;EACE,eAAA;AA/CN;AAkDI;EACE,eAAA;AAhDN;AAoDE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAlDJ;AAoDI;EACE,eAAA;EACA,wCAAA;EACA,kBAAA;AAlDN;AAqDI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,0CAAA;EACA,wCAAA;EACA,kBAAA;AAnDN;AAsDI;EACE,OAAA;EACA,cAAA;EACA,gDAAA;EACA,kBAAA;EA/UJ,gCAAA;EACA,gEAAA;AA4RF;AA1RE;EACE,qBAAA;EACA,sBAAA;AA4RJ;AAzRE;EACE,kCAAA;AA2RJ;AAxRE;EACE,+CAAA;EACA,6BAAA;AA0RJ;AAxRI;EACE,+CAAA;AA0RN;AAtRE;EACE,kCAAA;AAwRJ;AAoCM;EACE,WAAA;EACA,eAAA;AAlCR;AAoCQ;EACE,iBAAA;EACA,sBAAA;AAlCV;AAqCQ;EACE,yEAAA;EACA,gBAAA;EACA,MAAA;EACA,gBAAA;AAnCV;;AA8CM;EACE,oFAAA;EACA,mDAAA;AA3CR;AA+CM;EACE,2CAAA;AA7CR;;AAwDI;;;EACE,aAAA;AAnDN;AAsDI;;;EACE,eAAA;AAlDN;AAqDI;;;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AAjDN;;AAuDA;EACE,4CAAA;AApDF;;AAyDE;EACE,mDAAA;EACA,qBAAA;AAtDJ;AAwDI;EACE,uBAAA;AAtDN;AAyDI;EACE,qBAAA;AAvDN;AA2DE;EACE,wBAAA;AAzDJ;;AA6DA;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AA1DF;;AA+DE;EACE,6DAAA;EAGA,gCAAA;EACA,gEAAA;AA9DJ;AAgEI;EACE,qBAAA;AA9DN;AAiEI;EACE,kCAAA;AA/DN;AAkEI;EACE,+CAAA;EACA,6BAAA;AAhEN;AAkEM;EACE,+CAAA;AAhER;AAoEI;EACE,2CAAA;AAlEN;AAoEM;EACE,2DAAA;AAlER;AAqEM;EACE,6DAAA;EACA,qDAAA;AAnER","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n// Scrollbar styling - use rgba values for reliable cross-theme support\n// Needs !important to override global preset styles in styles.scss\n@mixin themed-scrollbar {\n  scrollbar-width: thin !important;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;\n\n  &::-webkit-scrollbar {\n    width: 8px !important;\n    height: 8px !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7) !important;\n    border-radius: 4px !important;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9) !important;\n    }\n  }\n\n  &::-webkit-scrollbar-corner {\n    background: transparent !important;\n  }\n}\n\n.content.gridster-item-content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n  height: calc(100% - 30px);\n}\n\n// Master-detail layout\n.master-detail {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n// Left panel - feature list\n.list-panel {\n  width: 220px;\n  min-width: 180px;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid var(--mat-sys-outline-variant);\n  background: var(--mat-sys-surface);\n  overflow: hidden;\n\n  .list-header {\n    flex-shrink: 0;\n    border-bottom: 1px solid var(--mat-sys-outline-variant);\n  }\n\n  .feature-list {\n    flex: 1;\n    overflow-y: auto;\n    min-height: 0;\n    @include themed-scrollbar;\n  }\n\n  .feature-item {\n    padding: 10px 12px;\n    cursor: pointer;\n    border-bottom: 1px solid var(--mat-sys-outline-variant);\n    transition: background-color 0.1s ease;\n\n    &:hover {\n      background: var(--mat-sys-surface-variant);\n    }\n\n    &.selected {\n      background: var(--mat-sys-primary-container);\n      border-left: 3px solid var(--mat-sys-primary);\n      padding-left: 9px;\n    }\n\n    .feature-name {\n      display: block;\n      font-weight: 500;\n      font-size: 13px;\n      margin-bottom: 2px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .script-name {\n      display: block;\n      font-size: 11px;\n      color: var(--mat-sys-on-surface-variant);\n      font-family: monospace;\n    }\n  }\n\n  .empty-state {\n    padding: 24px 12px;\n    text-align: center;\n    color: var(--mat-sys-on-surface-variant);\n    font-size: 13px;\n\n    p {\n      margin: 0;\n    }\n  }\n\n  .list-footer {\n    flex-shrink: 0;\n    padding: 8px;\n    border-top: 1px solid var(--mat-sys-outline-variant);\n\n    button {\n      width: 100%;\n      justify-content: flex-start;\n    }\n  }\n}\n\n// Right panel - detail view\n.detail-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--mat-sys-surface-container);\n}\n\n.no-selection {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--mat-sys-on-surface-variant);\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 12px;\n    opacity: 0.5;\n  }\n\n  p {\n    margin: 0;\n  }\n}\n\n// Loading state\n.loading-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n// Detail header\n.detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--mat-sys-outline-variant);\n  background: var(--mat-sys-surface);\n  flex-shrink: 0;\n\n  h3 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .header-actions {\n    display: flex;\n    gap: 4px;\n  }\n}\n\n// New feature form\n.new-feature-form {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  .form-section {\n    flex: 1;\n    padding: 16px;\n    overflow-y: auto;\n  }\n\n  .section-label {\n    font-size: 13px;\n    color: var(--mat-sys-on-surface-variant);\n    margin-bottom: 12px;\n  }\n\n  .script-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .script-option {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 12px;\n    border-radius: 4px;\n    background: var(--mat-sys-surface);\n    border: 1px solid var(--mat-sys-outline-variant);\n    cursor: pointer;\n    font-size: 13px;\n\n    &:hover {\n      background: var(--mat-sys-surface-variant);\n      border-color: var(--mat-sys-primary);\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      color: var(--mat-sys-primary);\n    }\n  }\n\n  .full-width {\n    width: 100%;\n  }\n\n  .selected-script {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 12px 0;\n    font-size: 13px;\n    color: var(--mat-sys-on-surface-variant);\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 16px;\n  }\n}\n\n// Form pane (parameters)\n.form-pane {\n  padding: 16px;\n  border-bottom: 1px solid var(--mat-sys-outline-variant);\n  background: var(--mat-sys-surface);\n  flex-shrink: 0;\n\n  .params-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n\n    .param-field {\n      flex: 0 0 calc(33.333% - 8px);\n      min-width: 150px;\n    }\n  }\n\n  .no-params {\n    color: var(--mat-sys-on-surface-variant);\n    font-size: 13px;\n    font-style: italic;\n\n    p {\n      margin: 0;\n    }\n  }\n}\n\n// Test pane\n.test-pane {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  overflow: hidden;\n\n  .test-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 12px;\n\n    .dataset-field {\n      flex: 0 0 180px;\n    }\n\n    .index-field {\n      flex: 0 0 150px;\n    }\n  }\n\n  .test-output {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    .output-timestamp {\n      font-size: 11px;\n      color: var(--mat-sys-on-surface-variant);\n      margin-bottom: 8px;\n    }\n\n    .output-error {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 12px;\n      background: var(--mat-sys-error-container);\n      color: var(--mat-sys-on-error-container);\n      border-radius: 4px;\n    }\n\n    .output-table-container {\n      flex: 1;\n      overflow: auto;\n      border: 1px solid var(--mat-sys-outline-variant);\n      border-radius: 4px;\n      @include themed-scrollbar;\n\n      .output-table {\n        width: 100%;\n        font-size: 12px;\n\n        th, td {\n          padding: 6px 10px;\n          font-family: monospace;\n        }\n\n        th {\n          background: var(--preset-card, var(--mat-sys-surface-container, #f5f5f5));\n          position: sticky;\n          top: 0;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n}\n\n// Fix sticky header background for mat-table - use opaque theme-aware colors\n::ng-deep {\n  .output-table {\n    .mat-mdc-header-row {\n      .mat-mdc-header-cell {\n        background: var(--preset-card, var(--mat-sys-surface-container, #f5f5f5)) !important;\n        color: var(--mat-sys-on-surface-variant) !important;\n      }\n    }\n    .mat-mdc-row {\n      .mat-mdc-cell {\n        color: var(--mat-sys-on-surface) !important;\n      }\n    }\n  }\n}\n\n// Compact form fields\n::ng-deep {\n  .param-field,\n  .dataset-field,\n  .index-field {\n    .mat-mdc-form-field-subscript-wrapper {\n      display: none;\n    }\n\n    .mat-mdc-text-field-wrapper {\n      padding: 0 12px;\n    }\n\n    .mat-mdc-form-field-infix {\n      padding-top: 8px;\n      padding-bottom: 8px;\n      min-height: 40px;\n    }\n  }\n}\n\n// Active menu item\n.mat-menu-item.active {\n  background: var(--mat-sys-primary-container);\n}\n\n// Calculate button with spinner\n::ng-deep .calculate-btn.calculating {\n  &.mat-mdc-raised-button:disabled {\n    background-color: var(--mat-sys-primary) !important;\n    opacity: 1 !important;\n\n    .mdc-button__label {\n      color: white !important;\n    }\n\n    .mat-mdc-button-persistent-ripple {\n      opacity: 0 !important;\n    }\n  }\n\n  .mat-mdc-progress-spinner circle {\n    stroke: white !important;\n  }\n}\n\n.button-spinner {\n  display: inline-block;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n// Fix dropdown styling - ensure proper theming\n::ng-deep {\n  .mat-mdc-select-panel {\n    background-color: var(--mat-sys-surface-container) !important;\n\n    // Themed scrollbar for dropdown list\n    scrollbar-width: thin !important;\n    scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;\n\n    &::-webkit-scrollbar {\n      width: 8px !important;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent !important;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(155, 155, 155, 0.7) !important;\n      border-radius: 4px !important;\n\n      &:hover {\n        background: rgba(155, 155, 155, 0.9) !important;\n      }\n    }\n\n    .mat-mdc-option {\n      color: var(--mat-sys-on-surface) !important;\n\n      &:hover:not(.mdc-list-item--disabled) {\n        background-color: var(--mat-sys-surface-variant) !important;\n      }\n\n      &.mdc-list-item--selected:not(.mdc-list-item--disabled) {\n        background-color: var(--mat-sys-primary-container) !important;\n        color: var(--mat-sys-on-primary-container) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
